// Available ticket marketplace sites/platforms
export const TICKET_SITES = [
  { 
    id: 'official_club_site', 
    name: 'Official Club Site',
    displayName: 'Official Club Site',
    description: 'Official team/club website',
    icon: 'home-outline'
  },
  { 
    id: 'stubhub', 
    name: 'StubHub',
    displayName: 'StubHub',
    description: 'Global ticket marketplace',
    icon: 'ticket-outline'
  },
  { 
    id: 'livefootballtickets', 
    name: 'LiveFootballTickets',
    displayName: 'LiveFootballTickets',
    description: 'Football ticket marketplace',
    icon: 'football-outline'
  },
  { 
    id: 'footballticketnet', 
    name: 'FootballTicketNet',
    displayName: 'FootballTicketNet',
    description: 'Football ticket marketplace',
    icon: 'football-outline'
  },
  { 
    id: 'ticketmaster', 
    name: 'TicketMaster',
    displayName: 'TicketMaster',
    description: 'Official ticket marketplace',
    icon: 'ticket-outline'
  },
  { 
    id: 'viagogo', 
    name: 'Viagogo',
    displayName: 'Viagogo',
    description: 'Global ticket marketplace',
    icon: 'globe-outline'
  },
  { 
    id: 'seatgeek', 
    name: 'SeatGeek',
    displayName: 'SeatGeek',
    description: 'Ticket marketplace',
    icon: 'ticket-outline'
  },
  { 
    id: 'fanpass', 
    name: 'FanPass',
    displayName: 'FanPass',
    description: 'Digital ticket marketplace',
    icon: 'ticket-outline'
  },
  { 
    id: 'other', 
    name: 'Other',
    displayName: 'Other Site',
    description: 'Other marketplace',
    icon: 'globe-outline'
  }
] as const;

// Helper function to get site by ID
export const getSiteById = (id: string) => {
  return TICKET_SITES.find(site => site.id === id);
};

// Helper function to get site display name
export const getSiteDisplayName = (id: string) => {
  const site = getSiteById(id);
  return site?.displayName || id;
};

// Helper function to get default site (Official Club Site)
export const getDefaultSite = () => {
  return TICKET_SITES[0]; // Official Club Site is first in the array
};

// Type for site IDs
export type TicketSiteId = typeof TICKET_SITES[number]['id'];